export function initialize(): void {
  // ember-simple-auth will automatically restore sessions on app startup
  // The configuration is handled in config/environment.js
  // The backend authenticator will be used when specified during authentication
}

export default {
  name: 'ember-simple-auth-setup',
  initialize,
};
